import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ---------------------------------------------------------------------------
// הגנה מפני קריסת React כש-Google Translate פעיל (דף לבן בלחיצה על "חשב").
// גוגל עוטף טקסט ב-<font>, ואז React מנסה להחליף/להסיר text node ש"הוזז"
// תחת העטיפה, וקורא ל-removeChild/insertBefore על parent לא נכון → חריגה
// לא-מטופלת → כל עץ ה-React קורס. עוטפים את שתי המתודות כך שבמקרה של parent
// לא תואם הן מתעלמות בחן במקום לזרוק. React issue #11538. רץ פעם אחת.
// ---------------------------------------------------------------------------
if (typeof Node === 'function' && Node.prototype) {
  const nodeProto = Node.prototype as any;

  const originalRemoveChild = nodeProto.removeChild;
  nodeProto.removeChild = function (this: Node, child: any) {
    if (child && child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = nodeProto.insertBefore;
  nodeProto.insertBefore = function (
    this: Node,
    newNode: any,
    referenceNode: any
  ) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
